/**
 * Cdivider Component
 * Simple divider line for separating content sections
 */

'use client';

import { Ccontainer } from '../Ccontainer';
import { ColorType } from '@/theme/colors';
import type { CSSProperties } from 'react';

export enum DividerOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export interface CdividerProps {
  orientation?: DividerOrientation;
  color?: ColorType;
  opacity?: number;
  thickness?: number;
  length?: number | string;
  className?: string;
  style?: CSSProperties;
}

export function Cdivider({
  orientation = DividerOrientation.Horizontal,
  color = ColorType.Accent,
  opacity = 0.15,
  thickness = 1,
  length = '100%',
  className,
  style,
}: CdividerProps) {
  // Build debug prefix for passing to child components
  
  const isHorizontal = orientation === DividerOrientation.Horizontal;

  const dividerStyle: CSSProperties = {
    width: isHorizontal ? length : `${thickness}px`,
    height: isHorizontal ? `${thickness}px` : length,
    display: 'flex',
    ...style,
  };

  return (
    <Ccontainer
      backgroundColor={color}
      backgroundOpacity={opacity}
      padding={0}
      radius={0}
      borderWidth={0}
      className={className}
      style={dividerStyle}
    />
  );
}
